import React from "react";
import { up } from "styled-breakpoints";
import { useBreakpoint } from "styled-breakpoints/react-styled";
import LargePictureGallery from "~/components/PictureGallery/LargePictureGallery";
import { Picture } from "~/components/PictureGallery/Picture";
import SmallPictureGallery from "~/components/PictureGallery/SmallPictureGallery";

export type PictureGalleryProps = {
  gallery: Array<Picture>;
};

const PictureGallery = ({ gallery }: PictureGalleryProps) => {
  const isMdScreen = useBreakpoint(up("md"));

  if (isMdScreen) {
    return <LargePictureGallery gallery={gallery} />;
  }

  return <SmallPictureGallery gallery={gallery} />;
};

export default PictureGallery;
